// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b5d8a-button{display:flex}", "",{"version":3,"sources":["webpack://./app/components/FilterDropdown/style.scss"],"names":[],"mappings":"AAEA,cACE,YAAA","sourcesContent":["@import \"theme\";\n\n.button {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "b5d8a-button"
};
export default ___CSS_LOADER_EXPORT___;
